import styled from 'styled-components';
import { StyledEmbeddedWidgetCon } from '../../../skins';

import { MButton } from '../../../../atoms/MButton';

export const StyledTileEmbeddedWidgetCon = styled(StyledEmbeddedWidgetCon)`
  & .mr-embedded-widget__products-container {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin: 0 0 12px 0;
  }
`;

export const StyledTileProductItemCon = styled(MButton)`
  gap: 0px;
`;
